import React, { useEffect } from 'react';
import Card from '@applied/dragonfruit/src/components/Card/Card';
import Icon from '@applied/dragonfruit/src/components/Icon/Icon';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { useAppliedLogoSrc } from 'utils/reskin_utils';

import '../basic-page-style.scss';

export function ExpiredPage(): JSX.Element {
  const logoSrc = useAppliedLogoSrc();
  useEffect(function updateTabTitle() {
    document.title = 'Offer Expired';
  }, []);

  return (
    <Flex className="basic-page" justify="center" alignment="center">
      <Card
        className="content-container"
        direction="column"
        padding="xxl"
        gap="md"
        alignment="center"
        justify="center"
      >
        <Flex direction="row" alignment="center" justify="center">
          <Icon src={logoSrc} height={76.8} />
          <Typography variant="title">This offer is expired</Typography>
        </Flex>
        <Typography variant="body">
          Please reach out to your recruiter if this is an error. Otherwise, we wish you the best of
          luck and thank you for your interest in Applied Intuition!
        </Typography>
      </Card>
    </Flex>
  );
}
